import { ChipGroup_Item_default } from "./chunk-POKJKC2T.js";
import { ChipGroup_default } from "./chunk-VW2RNMK2.js";

// src/components/ChipGroup/index.ts
var ChipGroupComponent = ChipGroup_default;
ChipGroupComponent.Item = ChipGroup_Item_default;
ChipGroupComponent.Item.displayName = "ChipGroup.Item";
export { ChipGroupComponent };